const generateDataFromSpecificsAmount = (moduleAmount) => {
  const dataGenerate = [];

  for (let i = 0; i < moduleAmount; i++) {
    const index = i + 1;

    const format = {
      id: index,
      label: `Module ${index}`,
      placeholder: `MODULE ${index}`,
      module: `module-${index}`,
      name: `${index}주차`,
    };

    if (index === moduleAmount) {
      format.name = "보강주";
    }

    dataGenerate.push(format);
  }

  return dataGenerate;
};

export { generateDataFromSpecificsAmount };
